import React from 'react';
import { CheckIcon, FlameIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const bundle = [{
  emoji: '🤖',
  label: 'MakerLab — Oltre 100 progetti di robot',
  value: '$47,00'
}, {
  emoji: '🎥',
  label: 'Bonus n. 1: Pacchetto Arcade di cartone',
  value: '$25,00'
}, {
  emoji: '✂️',
  label: 'Bonus n. 2: La guida ai lavoretti di carta in 5 minuti',
  value: '$19,00'
}, {
  emoji: '🌈',
  label: 'Bonus n. 3: Piccoli creatori: slime e giochi sensoriali',
  value: '$19,00'
}];
export function Offer() {
  return <section id="angebot" className="w-full bg-cream py-16 sm:py-24" data-id="element-122" data-mp="13yc9xpenils4">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-123" data-mp="ywwqg1s4gnbu">
        <SectionHeading eyebrow="✦ Tutto ciò che ricevi oggi" title={<>Il pacchetto MakerLab completo</>} data-id="element-124" data-mp="2fc682rdij8jk" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-xl" data-id="element-125" data-mp="2ac1sr4occjux">
          <ul className="divide-y divide-ink/10" data-id="element-126" data-mp="pj5tkl34eccf">
            {bundle.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-127" data-mp="uiiolt45apq3">
                <span className="flex items-center gap-3 text-sm font-semibold text-ink" data-id="element-128" data-mp="zgafqkwyu7t8">
                  <span className="text-xl" aria-hidden="true" data-id="element-129" data-mp="13j730oxgas3i">
                    {item.emoji}
                  </span>
                  {item.label}
                </span>
                <span className="flex-none text-sm font-medium text-ink/40 line-through" data-id="element-130" data-mp="btlupqcntz8e">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="space-y-2 bg-ink px-6 py-8 text-center text-white" data-id="element-131" data-mp="km5wv0s5ulxz">
            <p className="text-sm text-white/60" data-id="element-132" data-mp="3k95jac2dyth4">
              Valore totale <span className="line-through" data-id="element-133" data-mp="3k6ja67zuk5ws">$110,00</span>
            </p>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wide text-sunshine" data-id="element-134" data-mp="3o8o3f5mdv0iw">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-135" data-mp="vde4kuzmtk0w" />
              Solo oggi paghi
            </p>
            <p className="font-display text-5xl font-black" data-id="element-136" data-mp="155k6oxjllhtt">$19,00</p>
            <p className="text-sm font-semibold text-emerald-400" data-id="element-137" data-mp="154qwfmlfka6x">
              🎉 Oggi risparmi $91,00
            </p>

            <div className="pt-4" data-id="element-138" data-mp="108tjzrdafnzf">
              <CtaButton href="https://curiousmindshub.impultienda.ar/checkout" className="w-full sm:w-auto" data-id="element-139" data-mp="cg38tkd7l8q7">
                Sì! Voglio tutto a soli $19
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-col items-center gap-2 text-sm text-white/70 sm:flex-row sm:justify-center sm:gap-6" data-id="element-140" data-mp="lfghwbxf7vae">
              {['Accesso digitale immediato', 'Tutti i 3 bonus inclusi', 'Pagamento unico, nessun abbonamento'].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-141" data-mp="20engu9z5femr">
                  <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-142" data-mp="20dcd2a5pe6vn" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink/50" data-id="element-143" data-mp="1vf13m0jblydy">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="2j5eydytaibc8" />
          Accesso immediato dopo l’acquisto · Oltre 40.938 download
        </p>
      </div>
    </section>;
}